/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";

export const KillswitchOverlapStatus = {
  Active: "active",
  Scheduled: "scheduled",
} as const;
export type KillswitchOverlapStatus = OpenEnum<typeof KillswitchOverlapStatus>;

/** @internal */
export const KillswitchOverlapStatus$inboundSchema: z.ZodMiniType<
  KillswitchOverlapStatus,
  unknown
> = openEnums.inboundSchema(KillswitchOverlapStatus);
